import { inject, NgModule } from '@angular/core'
import { Route, RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'

import { APIService } from 'api'
import { LocaleModule } from 'common/locale'
import { UtilCommonModule } from 'common/util'
import { EntityListModule } from 'common/entityList'
import { IdentityService } from 'main/services/identity.service'
import { ProfileViewComponent } from 'main.profile/views/profileView.component'
import { UsersModule } from 'main.users'
import { NotificationModule } from 'notification'
import { makeReusableRoute } from 'root/routeReuseStrategy'

export const ROUTES: Route[] = [
  makeReusableRoute({
    path: '',
    pathMatch: 'full',
    component: ProfileViewComponent,
    resolve: {
      user: () => inject(APIService).main.getProfile(),
    },
    canActivate: [
      () => {
        return !inject(IdentityService).user?.isExternal
      },
    ],
  }),
  {
    path: 'api-playground',
    pathMatch: 'full',
    loadComponent: () => import('./views/apiPlaygroundView.component').then(m => m.APIPlaygroundViewComponent),
    canActivate: [
      () => {
        return !inject(IdentityService).user?.isExternal
      },
    ],
  },
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbNavModule,
    NgbDropdownModule,
    RouterModule.forChild([
      ...ROUTES,
    ]),
    LocaleModule.forChild(),
    UtilCommonModule,
    UsersModule,
    NotificationModule,
    EntityListModule,
    ProfileViewComponent,
  ],
})
export class ProfileModule {}

export default ProfileModule
